/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseClient } from '../base-client';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { SeedInfoDto as DemoSeedSeedInfoDto } from '../models/demo-seed/seed-info-dto';
import { seedSingleEnsemble } from '../fn/demo-seed/seed-single-ensemble';
import { SeedSingleEnsemble$Params } from '../fn/demo-seed/seed-single-ensemble';

@Injectable({ providedIn: 'root' })
export class DemoSeedClient extends BaseClient {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `demoSeedSeedSingleEnsemble()` */
  static readonly DemoSeedSeedSingleEnsemblePath = '/demo-seed/single-ensemble';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `seedSingleEnsemble()` instead.
   *
   * This method doesn't expect any request body.
   */
  seedSingleEnsemble$Response(context?: HttpContext): Observable<StrictHttpResponse<DemoSeedSeedInfoDto>> {
    const obs = seedSingleEnsemble(this.http, this.rootUrl, {} satisfies SeedSingleEnsemble$Params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `seedSingleEnsemble$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  seedSingleEnsemble(context?: HttpContext): Observable<DemoSeedSeedInfoDto> {
    const resp = this.seedSingleEnsemble$Response(context);
    return resp.pipe(
      map((r: StrictHttpResponse<DemoSeedSeedInfoDto>): DemoSeedSeedInfoDto => r.body)
    );
  }

}
